import {Radio} from 'antd'
import styled, {css} from 'styled-components'

import theme, {media} from '@/src/config/theme'

import {FormUI} from '@/src/shared/modules/form'

import Button from '@/src/shared/ui/button'
import {Collapse} from '@/src/shared/ui/collapse'

export const FormTemplate = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;

  & > * {
    max-width: unset;
  }

  & ${FormUI.Container} {
    display: flex;
    flex-direction: column;

    align-items: center;
  }

  & ${FormUI.Title} {
    width: 100%;
    max-width: ${theme.sizes.container}px;
  }

  & ${FormUI.Head} {
    border: unset;
    padding: unset;
    display: flex;
    justify-content: center;

    > div {
      font-size: 1.875rem;
      font-weight: 450;

      text-decoration: underline;
    }
  }
`

export const City = styled.div`
  font-size: 1.25rem;
  font-weight: 450;
  padding: 22px 35px;
  background: ${theme.colors.gray7};

  display: none;

  @media ${media.md} {
    display: block;
  }
`

export const Container = styled.div`
  width: 100%;
  max-width: ${theme.sizes.container}px;
`

export const ShopList = styled.div`
  display: flex;
  flex-direction: column;
`

export const CollapseShopList = styled(Collapse)`
  display: block;

  @media ${media.md} {
    display: none;
  }
`

export const ShopItem = styled.div<{$active: boolean; $collapse?: boolean}>`
  transition: transform ease 0.3s;
  display: flex;
  flex-direction: column;

  gap: 10px;
  cursor: pointer;
  padding: 18px 15px;

  ${props =>
    !props.$collapse &&
    css`
      display: none;
    `};

  @media ${media.md} {
    border-bottom: solid 1px ${theme.colors.gray6};

    display: flex;
    padding-right: 4.25rem;
    flex-direction: row;
    gap: 33px;
    text-align: unset;
    align-items: center;
    text-align: center;

    ${ShopList} &:last-child {
      margin-bottom: 3.75rem;
    }

    ${props =>
      props.$active &&
      css`
        background: ${theme.colors.dark4};

        * {
          color: ${theme.colors.white};
        }
      `}
    &:hover {
      background: ${theme.colors.dark4};

      * {
        color: ${theme.colors.white};
      }

      transform: scale(1.015);
    }
  }
`

export const ItemRadio = styled(Radio)`
  padding-left: 33px;
  display: none;

  @media ${media.md} {
    display: initial;
  }
`

export const ShopItemName = styled.div`
  width: 150px;

  font-size: 1.25rem;
  font-weight: 450;
`

export const ShopItemAddress = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  flex: 1;
  // display: flex;
  // flex-direction: column;
  //
  @media ${media.md} {
    justify-content: center;
    width: 176px;
    text-align: right;
  }
`

export const ShopItemSchedule = styled.div`
  white-space: normal;
  text-align: left;

  @media ${media.md} {
    width: 129px;
  }
`

export const Map = styled.div`
  box-sizing: border-box;
  min-height: 632px;
  padding-top: 32px;
  width: 100%;
`

export const SeeButton = styled(Button)`
  padding-left: unset;
  padding-right: unset;

  border-top-style: unset;
  border-left-style: unset;
  border-right-style: unset;

  border-radius: unset;

  font-weight: 450;

  width: fit-content;

  display: flex;

  @media ${media.md} {
    display: none;
  }
`
export const CollapseByCity = styled.div`
  margin-top: 6px;
  border: unset;
  display: block;

  & > .ant-collapse-item > .ant-collapse-header {
    background: ${theme.colors.dark};
    color: ${theme.colors.white};
    border-radius: 8px 8px 8px 8px !important;
  }

  & > .ant-collapse-item > .ant-collapse-content {
    border: unset;

    & > .ant-collapse-content-box {
      padding: unset;
    }
  }

  @media ${media.md} {
    display: none;
  }
`
